export default "__VITE_PUBLIC_ASSET__cc51be36__"